/**
 * HeaderCtrl controller
 * Site header navigation, notifications, etc
 */

import moment from 'moment'

/**
 * HeaderCtrl controller
 *
 * @class HeaderCtrl
 * @memberof mwApp/common
 * @see mwApp/common
 * @listens mwApp.event:changePasswordRequired
 *
 * @ngdoc controller
 * @name mwApp/common.controller:HeaderCtrl
 */
/* @ngInject */
export default function HeaderCtrl ($scope, $uibModal, $state, $interval, $location, authSvc, notifySvc, breadcrumbsSvc, storageSvc) {
  var vm = this
  const allColors = ['', 'green', 'purp', 'orange', '']

  vm.APP_NEW_USER_GUIDE_SUPPORT_ENABLED = window.ENV.APP_NEW_USER_GUIDE_SUPPORT_ENABLED

  const storage = storageSvc.local

  const userGuideLinks = {
    332: 'https://drive.google.com/drive/folders/135UzLUnlHFqpLvtlGkmXT3tWwWtgz-3C',
    995: 'https://drive.google.com/drive/folders/135UzLUnlHFqpLvtlGkmXT3tWwWtgz-3C',
    default: 'https://helpdesk.setplex.com/portal/en/kb/articles/noramw-user-guide-v-3-15'
  }

  const systemInfo = storage.get('systemInfo', null)

  vm.userGuideLink = (systemInfo && userGuideLinks[systemInfo.PID]) || userGuideLinks.default
  vm.newUserGuideLink = `${$location.protocol()}://${$location.host()}/guide`

  const handlerKeydown = (event) => {
    if (event.keyCode > 48 && event.keyCode < 54 && event.ctrlKey) {
      event.preventDefault()
      vm.changeColor(allColors[event.keyCode - 49] || '')
    }
  }
  document.addEventListener('keydown', handlerKeydown)

  vm.changeColor = function (color) {
    const bodyTag = angular.element(document.querySelector('body'))
    allColors.forEach(c => { bodyTag.removeClass(c) })
    color && bodyTag.addClass(color)
  }

  /**
   * Server timezone
   *
   * @memberof mwApp/common.controller:HeaderCtrl
   * @type {String}
   */
  vm.timezone = storageSvc.local.get('timezone')

  vm.isAuthenticated = authSvc.isAuthenticated()

  vm.timezoneOffset = storageSvc.local.get('timezoneOffset')

  /**
   * Server time
   *
   * @memberof mwApp/common.controller:HeaderCtrl
   * @type {String}
   */
  vm.time = ''

  function updateTime () {
    vm.time = moment().utc().add(vm.timezoneOffset, 'hours').format('HH:mm')
  }

  updateTime()

  /**
   * Server date
   *
   * @memberof mwApp/common.controller:HeaderCtrl
   * @type {String}
   */
  vm.date = ''

  function updateDate () {
    var now = moment().utc().add(vm.timezoneOffset, 'hours')
    vm.date = (now.date() !== new Date().getDate())
      ? now.format('Do of MMMM')
      : ''
  }

  updateDate()

  // set intervals for update clock and date
  $interval(updateTime, 3000)
  $interval(updateDate, 600000) // 10 minutes

  /**
   * Breadcrumbs service
   *
   * @memberof mwApp/common.controller:HeaderCtrl
   * @type {mwApp/common.service:breadcrumbsSvc}
   */
  vm.breadcrumbs = breadcrumbsSvc

  /**
   * User object
   *
   * @memberof mwApp/common.controller:HeaderCtrl
   * @type {models.User}
   */
  vm.user = authSvc.getUser()

  /**
   * Notify service
   *
   * @memberof mwApp/common.controller:HeaderCtrl
   * @type {mwApp/common.service:notifySvc}
   */
  vm.notify = notifySvc

  /**
   * Do logout
   *
   * @memberof mwApp/common.controller:HeaderCtrl
   */
  vm.logout = function () {
    authSvc.doLogout()
      .finally(
        () => {
          notifySvc.clear()
          $state.go('login')
        }
      )
  }

  /**
   * Change password
   *
   * @memberof mwApp/common.controller:HeaderCtrl
   */
  vm.changePassword = function () {
    $uibModal.open({
      animation: false,
      backdropClass: 'modal-top', // set z-index to 100500
      windowClass: 'modal-top', // set z-index to 100510
      templateUrl: 'components/auth/views/changePassword.html',
      controller: 'ChangePasswordCtrl as vm',
      size: 'lg',
      backdrop: 'static'
    }).result
      .then(
        () => {
          vm.user.pwdChange = false
          authSvc.setUser(vm.user)
        }
      )
  }

  /**
   * On 'event:changePasswordRequired' show change password form
   */
  $scope.$on('event:changePasswordRequired', function () {
    vm.changePassword()
  })

  // if controller is loaded and flag in 'pwdChange' in 'user' object already set to 'true'
  // server had requiested to change password earlier, before we could catch 'changePasswordRequired' event
  if (vm.user.pwdChange) {
    vm.changePassword()
  }

  vm.showLicenseWarning = function () {
    // TODO: refactored with condition
    if (storageSvc.local.get('licenseWarning')) {
      return JSON.parse(storageSvc.local.get('licenseWarning'))
    }
    return false
  }

  /**
   * Feedback
   *
   * @memberof mwApp/common.controller:HeaderCtrl
   */
  vm.feedback = function () {
    return $uibModal.open({
      animation: false,
      backdropClass: 'modal-top', // set z-index to 100500
      windowClass: 'modal-top', // set z-index to 100510
      templateUrl: 'components/auth/views/feedback.html',
      controller: 'FeedbackCtrl as vm',
      size: 'lg',
      backdrop: 'static'
    }).result
  }

  vm.setHash = function (breadcrumb) {
    if (breadcrumb.name === 'contentSets' && storageSvc.get('contentHash')) {
      return '#' + storageSvc.get('contentHash')
    }
    return ''
  }

  vm.showDashboardLabel = function () {
    if (authSvc.hasEnabledFlag('FEATURE_SECURED_DASHBOARD_ENABLED') && !authSvc.hasAccess('viewDashboard')) {
      return 'Home'
    }
    return 'Dashboard'
  }

  vm.aiChat = false

  vm.openAiChat = function () { vm.aiChat = true }

  vm.closeAiChat = function () { vm.aiChat = false }
}
